/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CompanyTable_company$ref: FragmentReference;
declare export opaque type CompanyTable_company$fragmentType: CompanyTable_company$ref;
export type CompanyTable_company = {
  +id: string,
  +code: number,
  +name: string,
  +abbr: ?string,
  +establishmentCode: ?number,
  +taxName: ?string,
  +isDisabled: boolean,
};
export type CompanyTable_company$data = CompanyTable_company;
export type CompanyTable_company$key = {
  +$data?: CompanyTable_company$data,
  +$fragmentRefs: CompanyTable_company$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CompanyTable_company",
  "type": "Company",
  "metadata": {
    "mask": false
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "abbr",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "establishmentCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "taxName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDisabled",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '24d5e8afda773578840bb8eeaec0cc8f';
module.exports = node;
